// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Header_cardWrapper__eSF4s"};